import modals from './modals/reducer';
import user from './user/reducer';
import vesting from './vesting/reducer';

export default {
  user,
  modals,
  vesting,
};
